// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cf6bc04d","239":"7dc12d16","455":"9bceb478"}[chunkId] + ".chunk.js";
};